<script>
  import { router } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FilterBar from '../../components/filter_bar.svelte'
  import SearchInput from '../../components/search_input.svelte'
  import FilterSelect from '../../components/filter_select.svelte'
  import Paginator from '../../components/paginator.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import { Button } from '../../components/ui'
  import { confirm } from '../../components/confirm.js'

  let {
    feeds = [],
    pagy = null,
    total_count = 0,
    filters = {},
    feed_type_options = [],
    title = 'Feeds'
  } = $props()

  // List writes redirect back to this (filtered, paged) URL server-side.

  const toggleActive = (item, active) => {
    router.patch(`/feeds/${item.id}`, { feed: { active } }, { preserveScroll: true, preserveState: true })
  }

  const archive = async (item) => {
    const confirmed = await confirm({
      title: item.feed_type !== 'standard' ? 'Non-standard Feed Archive' : 'Confirm Archive',
      variant: 'error',
      body:
        item.feed_type !== 'standard'
          ? 'It looks like you are archiving a non-standard feed. This is not suggested unless you plan to replace it with another after. Archiving is permanent unless reversed by a developer. Are you sure?'
          : 'Archiving is permanent unless reversed by a developer. Are you sure?'
    })
    if (!confirmed) return
    router.delete(`/feeds/${item.id}`, { preserveScroll: true })
  }

  // The server works out which row moved and where from the new order.
  const onReorder = (newItems) => {
    router.patch('/feeds/reorder', { ordered_ids: newItems.map((item) => item.id) }, { preserveScroll: true })
  }
</script>

<Layout>
  <PageHeader {title} subtitle="Manually ranked content feeds per college town" count={pagy.count} total={total_count}>
    {#snippet actions()}
      <Button href="/feeds/new" variant="primary" size="sm" icon="add">New Feed</Button>
    {/snippet}
  </PageHeader>

  <FilterBar>
    {#snippet start()}
      <SearchInput value={filters.search || ''} placeholder="Search feeds…" />
      <FilterSelect
        label="Type"
        param="feed_type"
        value={filters.feed_type || ''}
        placeholder="All types"
        options={feed_type_options}
      />
    {/snippet}
  </FilterBar>

  <EntityList entity="feed" rows={feeds} dragEnabled onreorder={onReorder} onToggle={toggleActive} onDelete={archive} />

  {#if pagy}<Paginator {...pagy} />{/if}
</Layout>
